export const nodeTypeKeys = {
  EVAL: "eval",
  DATA_SOURCE: "data-source",
  ACTION: "action",
  INITIAL: "initial",
  ACTIVITY: "activity",
  SLOT: "slot",
}
